import { literal, object, type InferOutput } from 'valibot'
import { Engine } from '../../../../engine/Engine.type'
import { EntityListSchema, type EntityList } from '../../../EntityList.type'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const SetEntsActionSchema = object({
  type: literal(ActionType.Map.SetEnts),
  ents: EntityListSchema,
})

export type SetEntsAction = InferOutput<typeof SetEntsActionSchema>

export function createSetEntsAction(ents: EntityList): SetEntsAction {
  return {
    type: ActionType.Map.SetEnts,
    ents,
  }
}

export async function handleSetEntsAction(
  engine: Engine,
  action: SetEntsAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  engine.state.ents = action.ents
}
